import React from 'react';
import styles from '../ReportModalXtram.module.scss';

/**
 * How the advances report is filed. A subordinate case is filed through its main case, so it can only be
 * marked unreported here. The PDF / report / close buttons live in the modal footer.
 */
const WithholdingModalActions = ({
    t,
    direction,
    reportingWay,
    setReportingWay,
    isSubordinateClient,
}) => {
    const options = [
        { value: 'automatic', label: t('AutomaticTaxAuthorityReporting'), disabled: isSubordinateClient },
        { value: 'manual', label: t('ManualReporting'), disabled: isSubordinateClient },
        { value: 'unreported', label: t('Unreported') },
    ];

    return (
        <div className={styles.panel} dir={direction}>
            <div className={styles.panelHeader}>{t('VatReportingWay')}</div>
            <div className={styles.panelBody}>
                <div className={styles.options} role="radiogroup">
                    {options.map((option) => {
                        const active = reportingWay === option.value;
                        return (
                            <button
                                key={option.value}
                                type="button"
                                role="radio"
                                aria-checked={active}
                                disabled={option.disabled}
                                className={`${styles.option} ${active ? styles.optionActive : ''}`}
                                onClick={() => setReportingWay(option.value)}
                            >
                                <span className={styles.optionDot} aria-hidden="true" />
                                {option.label}
                            </button>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default WithholdingModalActions;
